import { connect } from 'react-redux';
import RaceCards from '../components/RaceCards';

/**
 * React-redux bindings
 * @param {*} state the current state
 * @returns {object} props
 */
function mapStateToProps(state) {
    const eventId = state.selected_event_id || state.default_event_id;

    return {
        eventId,
        timeformEvents: state.timeform_events,
        racecardUrls: state.racecard_urls,
        events: state.events,
        selections: state.selections,
        typeCode: state.type_code,
        timeformSelections: state.timeform_selections,
        isLoading: state.isLoading,
        tournamentsDetails: state.tournaments_details,
    };
}

const RaceCardsContainer = connect(
    mapStateToProps,
    null,
)(RaceCards);

export default RaceCardsContainer;
